// extracted by mini-css-extract-plugin
export default {"center":"L3Jnh","left":"Uo1Xe","right":"nizm5","justifyContentCenter":"INow1","justifyContentLeft":"zBdRW","justifyContentRight":"HfbmN"};